import React, { Component } from 'react';
import { NavItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

class UserInfo extends Component {

  render() {
    const { user, userIdentified, selectedEmployer } = this.props;

    if (!userIdentified) {
      return null;
    }

    return (
      <div className="user-info-container">
        <NavItem className="user-name-info">{user.firstName} {user.lastName}</NavItem>
        { user.employers && user.employers.length > 0 && user.employers[selectedEmployer] && user.employers[selectedEmployer].name &&
        <NavItem className="user-company-info">{user.employers[selectedEmployer].name}</NavItem>
        }
      </div>
    );
  }
}

UserInfo.propTypes = {
  user: PropTypes.object.isRequired,
  userIdentified: PropTypes.bool.isRequired,
  selectedEmployer: PropTypes.number.isRequired
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/containers/UserInfo/UserInfo.jsx